import parsePhoneNumber, { CountryCode, getCountryCallingCode } from "libphonenumber-js/mobile";
import { object, string } from "zod";
import { PHONE_COUNTRY_CODE } from "../constants";

const testNumbers = ["500600700", "600700800"];

export const validatePhone = (value?: string, countryCode = "PL") => {
  if (!value) return false;
  if (testNumbers.includes(value.split(" ").join(""))) return true;

  const cc = countryCode.toUpperCase() as CountryCode;

  try {
    const phoneNumber = parsePhoneNumber(value, {
      defaultCountry: cc,
      defaultCallingCode: getCountryCallingCode(cc) as string,
    });

    return phoneNumber?.country === cc && phoneNumber.isValid();
  } catch (_error) {
    return false;
  }
};

export const phoneFormSchema = (t: ToDo, countryCode: string) =>
  object({
    phoneNumber: string().refine((v) => validatePhone(v, countryCode), t("validation.phone")),
  });

export const getPhoneCountryCode = (countryCode = "PL") => {
  switch (countryCode) {
    case "NO":
      return PHONE_COUNTRY_CODE.Norway;
    default:
      return PHONE_COUNTRY_CODE.Poland;
  }
};
